module.exports = __webpack_public_path__ + "media/images/icons/since-badge-en-99bde97397ad1b0eede84d49b522f8b7.svg";